__turbopack_context__.v({
  "date": "XIi3Xq_date",
  "dateRange": "XIi3Xq_dateRange",
  "deliveryDateSkeleton": "XIi3Xq_deliveryDateSkeleton",
  "srOnly": "XIi3Xq_srOnly",
  "stacked": "XIi3Xq_stacked",
});
